import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Controller, useForm } from "react-hook-form";
import DatePicker, { registerLocale } from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import CustomDateInput from "@/components/InputCustom/DateInput";
import Select from "react-select";

registerLocale("pt-BR", ptBR);

// Portal limpo: escapa do overflow-y-auto do modal sem interferir no posicionamento do popper.js
const CalendarPortal = ({ children }: { children?: React.ReactNode }) =>
  createPortal(<>{children}</>, document.body);

type UserSearchItem = {
  id?: number | string | null;
  name?: string | null;
  last_name?: string | null;
  filePath?: string | null;
  filepath?: string | null;
  img?: string | null;
  image?: string | null;
  url_img?: UserImageSource;
  user?: {
    id?: number | string | null;
    name?: string | null;
    last_name?: string | null;
    filePath?: string | null;
    filepath?: string | null;
    img?: string | null;
    image?: string | null;
    url_img?: UserImageSource;
  } | null;
};

type UserSelectOption = {
  value: number | string;
  label: string;
  image?: string | null;
};

type UserImageSource =
  | string
  | {
      url?: string | null;
      path?: string | null;
      filePath?: string | null;
      src?: string | null;
    }
  | null
  | undefined;

function resolveUserImageSrc(...sources: UserImageSource[]): string | null {
  for (const source of sources) {
    if (!source) continue;

    if (typeof source === "string") {
      const trimmedSource = source.trim();
      if (trimmedSource) return trimmedSource;
      continue;
    }

    const imageUrl =
      source.url ?? source.path ?? source.filePath ?? source.src ?? null;
    if (imageUrl?.trim()) return imageUrl;
  }

  return null;
}

import ImageGeneric from "@/assets/images/lg.png";
import { ServiceResumoDesk } from "@/services/serviceResumoDesk";
import { toast } from "react-toastify";
import notify from "@/services/notify.tsx";
import debounce from "lodash.debounce";
import ConfigDesks from "@/services/configDesks";
import UsersNewService from "@/services/usersNew";
import { useLayout } from "../../../../contexts/UseLayout";
import CadastroAgenciaService from "@/services/cadastroAgencia";
import Cleave from "cleave.js/react";
import ReactQuill from "react-quill";
import { ModalGeneric } from "../../../utils/ModalGeneric";
import { PlusCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import moment from "moment";

export function AddTask({ task, close, setDataTask, reload }: any) {
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const context: any = useLayout();
  const getAllTypesDesk = context?.getConfig?.typesDesks;

  const { register, handleSubmit, reset, setValue, watch, control } = useForm();

  const [users, setUsers] = useState<any>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [typesTask, setTypesTask] = useState<any>([]);
  const [typesPagamentoTask, setTypesPagamentoTask] = useState<any>([]);

  const [agencys, setAgencys] = useState<any>([]);
  const [loadingAgency, setLoadingAgency] = useState(false);

  const [clients, setClients] = useState<any>([]);

  const [protagonistas, setProtagonistas] = useState([]);
  const [loadigProtagonistas, setLoadigProtagonistas] = useState(false);

  const [subTasks, setSubTasks] = useState<any[]>([]);
  const [isSubTaskModalOpen, setIsSubTaskModalOpen] = useState(false);

  const addSubTask = (subTask: any) => {
    setSubTasks((prev) => [...prev, subTask]);
    setIsSubTaskModalOpen(false);
  };

  const removeSubTask = (index: number) => {
    setSubTasks((prev) => prev.filter((_, i) => i !== index));
  };

  const onSubmitSubTask = (data: any) => {
    addSubTask({
      title: data.subtarefa_title,
      description: data.subtarefa_description,
      status: 1,
      id_responsavel: data.subtarefa_id_responsavel.value,
    });

    setValue("subtarefa_title", "");
    setValue("subtarefa_description", "");
    setValue("subtarefa_id_responsavel", "");
  };

  const onSubmit = async (payload: any) => {
    const toastId = notify.loading("Salvando tarefa...");
    try {
      setIsSubmiting(true);
      payload.is_public = true;
      payload.subTarefa = JSON.stringify(subTasks);

      const removeNullUndefined = (obj: any) => {
        return Object.fromEntries(
          Object.entries(obj).filter(
            ([_, value]) => value !== null && value !== undefined,
          ),
        );
      };

      const formattedPayload: any = { ...payload };

      const cleanedPayload: any = removeNullUndefined(formattedPayload);

      if (cleanedPayload.id_responsavel) {
        cleanedPayload.id_responsavel = cleanedPayload.id_responsavel.value;
      }
      if (cleanedPayload.priority) {
        cleanedPayload.priority = cleanedPayload.priority.value;
      }
      if (cleanedPayload.id_type) {
        cleanedPayload.id_type = cleanedPayload.id_type.value;
      }
      if (cleanedPayload.id_type_desk) {
        cleanedPayload.id_type_desk = cleanedPayload.id_type_desk.value;
      }
      if (cleanedPayload.id_client) {
        cleanedPayload.id_client = cleanedPayload.id_client.value;
      }
      if (cleanedPayload.id_agency) {
        cleanedPayload.id_agency = cleanedPayload.id_agency.value;
      }
      if (cleanedPayload.id_protagonista) {
        cleanedPayload.id_protagonista = cleanedPayload.id_protagonista.value;
      }
      if (cleanedPayload.id_type_payment) {
        cleanedPayload.id_type_payment = cleanedPayload.id_type_payment.value;
      }
      if (cleanedPayload.valor_reembolso) {
        cleanedPayload.valor_reembolso = cleanedPayload.valor_reembolso
          .replace("R$ ", "")
          .replace(".", "")
          .replace(",", ".");
      }

      const formData = new FormData();

      for (const key in cleanedPayload) {
        if (cleanedPayload[key] !== undefined && cleanedPayload[key] !== null) {
          if (key === "file_id" && cleanedPayload[key]?.[0]) {
            formData.append(key, cleanedPayload[key][0]);
          } else {
            formData.append(key, cleanedPayload[key]);
          }
        }
      }

      let res;
      if (isEdit) {
        res = await ServiceResumoDesk.editTasks(formData, cleanedPayload.id);
      } else {
        formData.append("status", "1");
        res = await ServiceResumoDesk.addTasks(formData);
      }

      if (res.status === 200) {
        notify.update(
          toastId,
          "success",
          isEdit ? "Tarefa atualizada!" : "Tarefa criada!",
        );
        close(false);
        reset();
        reload();
        setDataTask(null);
      }
    } catch (error: any) {
      notify.update(
        toastId,
        "error",
        error?.response?.data?.msg ||
          error?.response?.data?.error ||
          "Erro ao salvar tarefa",
      );
    } finally {
      setIsSubmiting(false);
    }
  };

  useEffect(() => {
    if (task) {
      editTask(task);
    }
  }, [task]);

  async function editTask(task: any) {
    setValue("id_responsavel", {
      value: task?.id_responsavel,
      label: task?.responsavel?.name,
    });
    if (task.priority) {
      const priorityOptions = [
        { value: 1, label: "Alta" },
        { value: 2, label: "Média" },
        { value: 3, label: "Baixa" },
      ];

      const selectedPriority = priorityOptions.find(
        (option) => option.value === task.priority,
      );

      setValue("priority", selectedPriority || null);
    }
    if (task.id_type) {
      setValue("id_type", {
        value: task?.typeTarefa?.id,
        label: task?.typeTarefa?.name,
      });
    }
    if (task.id_type_desk) {
      setValue("id_type_desk", {
        value: task?.typeDesk?.id,
        label: task?.typeDesk?.name,
      });
    }
    if (task.id_agency) {
      setValue("id_agency", {
        value: task?.agency?.id,
        label: task?.agency?.name_fantasy,
      });
    }
    if (task.id_client) {
      setValue("id_client", {
        value: task?.cliente?.id,
        label: task?.cliente?.name_fantasy,
      });
    }
    if (task.id_protagonista) {
      setValue("id_protagonista", {
        value: task?.protagonista?.id,
        label: task?.protagonista?.name,
      });
    }
    if (task.id_type_payment) {
      setValue("id_type_payment", {
        value: task?.paymentType?.id,
        label: task?.paymentType?.name,
      });
    }
    if (task.valor_reembolso) {
      setValue("valor_reembolso", task?.valor_reembolso?.replace(".", ","));
    }

    setValue("title", task.title);
    setValue("description", task.description);
    setValue("date", moment.utc(task.date).format("YYYY-MM-DDTHH:mm"));
    setValue("status", task.status);
    setValue("id", task.id);
    setIsEdit(true);
  }

  function formatUserData(users: UserSearchItem[] = []): UserSelectOption[] {
    return users.reduce<UserSelectOption[]>((options, item) => {
      const user = item?.user ?? item;
      if (user?.id === undefined || user.id === null) {
        return options;
      }

      options.push({
        label:
          `${(user?.name || "").trim()} ${(user?.last_name || "").trim()}`.trim(),
        value: user.id,
        image: resolveUserImageSrc(
          user?.filePath,
          user?.filepath,
          user?.img,
          user?.image,
          user?.url_img,
          item?.filePath,
          item?.filepath,
          item?.img,
          item?.image,
          item?.url_img,
        ),
      });

      return options;
    }, []);
  }

  useEffect(() => {
    getTiposTarefa();
    getTiposPagamento();
  }, []);

  async function getTiposTarefa() {
    try {
      const { token } = JSON.parse(localStorage.getItem("token") || "{}");
      if (token) {
        const res = await ServiceResumoDesk.listTypesTarefa();
        if (res.status === 200) {
          setTypesTask(res.data.data);
        } else {
          toast.error("Não foi possível buscar Tipos de Desk");
        }
      }
    } catch (error) {
      console.log("Não foi possível buscar informações do usuário");
    }
  }

  async function getTiposPagamento() {
    try {
      const { token } = JSON.parse(localStorage.getItem("token") || "{}");
      if (token) {
        const res = await ServiceResumoDesk.listTypesPagamentoTarefa();
        if (res.status === 200) {
          setTypesPagamentoTask(res.data.data);
        } else {
          toast.error("Não foi possível buscar Tipos de Desk");
        }
      }
    } catch (error) {
      console.log("Não foi possível buscar informações do usuário");
    }
  }

  const loadUsers = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingUsers(true);
        try {
          const res = await UsersNewService.getUsuarios(inputValue, 1, 10);

          if (res?.status === 200) {
            setUsers(res?.data?.data?.data ?? []);
          }
        } catch {
          setUsers([]);
        } finally {
          setLoadingUsers(false);
        }
      } else {
        setUsers([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeUsers = (inputValue: any) => {
    loadUsers(inputValue);
    return inputValue;
  };

  const loadAgencias = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadingAgency(true);
        const res = await CadastroAgenciaService.listarAgencys(
          1,
          10,
          inputValue,
        );
        if (res.status === 200) {
          setAgencys(res.data.data);
        }
        setLoadingAgency(false);
      } else {
        setAgencys([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeAgencia = (inputValue: any) => {
    loadAgencias(inputValue);
    return inputValue;
  };

  const loadProtagonista = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadigProtagonistas(true);
        const res = await ConfigDesks.getContatosBusca(
          1,
          10,
          inputValue,
          "",
          watch("id_agency")?.value,
        );
        if (res.status === 200) {
          setProtagonistas(res.data.data);
        }
        setLoadigProtagonistas(false);
      } else {
        setProtagonistas([]);
      }
    }, 300),
    [],
  );

  const handleInputChangeProtagonista = (inputValue: any) => {
    loadProtagonista(inputValue);
    return inputValue;
  };

  return (
    <ModalGeneric
      onClose={() => {
        setDataTask(null);
        close(false);
        setIsEdit(false);
        reset();
      }}
      size="max-w-lg w-full max-h-[95%] overflow-y-auto text-sm"
    >
      <h2 className="text-xl font-medium">{t("tasks.form.title.addTask")}</h2>
      <form
        className="grid grid-cols-2 gap-3"
        onSubmit={handleSubmit(onSubmit)}
      >
        <label className="flex flex-col gap-1">
          <span>{t("tasks.form.fields.type.label")}</span>
          <Select
            placeholder={t("tasks.form.fields.type.placeholder")}
            className="text-center col-span-2"
            {...register("id_type")}
            onChange={(value: any) => setValue("id_type", value)}
            required
            value={watch("id_type")}
            isDisabled={!typesTask}
            options={
              typesTask && [
                ...typesTask?.map((e: any) => ({
                  value: e.id,
                  label: e.name,
                })),
              ]
            }
          />
        </label>
        {watch("id_type")?.value === 2 && (
          <label className="flex flex-col gap-1">
            <span>{t("tasks.form.fields.project.label")}</span>
            <Select
              placeholder={t("tasks.form.fields.project.placeholder")}
              onChange={(value: any) => {
                setValue("id_type_desk", value);
              }}
              className="text-center"
              value={watch("id_type_desk")}
              required
              isDisabled={!getAllTypesDesk}
              options={
                getAllTypesDesk && [
                  ...getAllTypesDesk?.map((e: any) => ({
                    value: e.id,
                    label: e.name,
                  })),
                ]
              }
            />
          </label>
        )}
        {watch("id_type")?.value === 3 && (
          <label className="flex flex-col gap-1">
            <span>{t("tasks.form.fields.paymentType.label")}</span>
            <Select
              placeholder={t("tasks.form.fields.paymentType.placeholder")}
              className="text-center"
              {...register("id_type_payment")}
              onChange={(value: any) => setValue("id_type_payment", value)}
              required
              value={watch("id_type_payment")}
              isDisabled={!typesPagamentoTask}
              options={
                typesPagamentoTask && [
                  ...typesPagamentoTask?.map((e: any) => ({
                    value: e.id,
                    label: e.name,
                  })),
                ]
              }
            />
          </label>
        )}
        <label className="flex flex-col gap-1 col-span-2">
          <span>{t("tasks.form.fields.title.label")}</span>
          <input
            type="text"
            placeholder={t("tasks.form.fields.title.placeholder")}
            className="bg-cinza-100 rounded-lg py-2 px-5 text-center"
            required
            {...register("title")}
          />
        </label>
        <label className="flex flex-col gap-1 col-span-2">
          {t("tasks.form.fields.description.label")}
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <ReactQuill
                {...field}
                className="bg-white w-full h-32 mb-11"
                theme="snow"
              />
            )}
          />
        </label>
        <label className="flex flex-col gap-1 col-span-2">
          <span>{t("tasks.form.fields.priority.label")}</span>
          <Select
            placeholder={t("tasks.form.fields.priority.placeholder")}
            className="text-center col-span-2"
            {...register("priority")}
            onChange={(value: any) => setValue("priority", value)}
            value={watch("priority")}
            options={[
              { value: 1, label: t("tasks.priority.high") },
              { value: 2, label: t("tasks.priority.medium") },
              { value: 3, label: t("tasks.priority.low") },
            ]}
          />
        </label>
        {(watch("id_type")?.value === 2 || watch("id_type")?.value === 3) && (
          <label className="flex flex-col gap-1">
            {t("tasks.form.fields.value.label")}
            <Controller
              name="valor_reembolso"
              control={control}
              render={({ field }) => (
                <Cleave
                  {...field}
                  options={{
                    numeral: true,
                    numeralThousandsGroupStyle: "thousand",
                    numeralDecimalMark: ",",
                    delimiter: ".",
                    prefix: "R$ ",
                  }}
                  placeholder={t("tasks.form.fields.value.placeholder")}
                  className="bg-cinza-100 rounded-lg py-2 px-5"
                />
              )}
            />
          </label>
        )}

        {watch("id_type")?.value === 2 && (
          <>
            <label className="flex flex-col gap-1">
              {t("tasks.form.fields.agency.label")}
              <Select
                {...register("id_agency")}
                required
                placeholder={t("tasks.form.fields.agency.placeholder")}
                onInputChange={handleInputChangeAgencia}
                isLoading={loadingAgency}
                value={watch("id_agency")}
                onChange={(value: any) => {
                  setValue("id_agency", value);
                  setClients(JSON.parse(value?.data?.base_clientes));
                }}
                options={[
                  ...agencys.map((e: any) => ({
                    value: e.id,
                    label: e.name_fantasy,
                    data: e,
                  })),
                ]}
                noOptionsMessage={() => t("common:type_to_search")}
              />
            </label>

            <label className="flex flex-col gap-1">
              {t("tasks.form.fields.client.label")}
              <Select
                {...register("id_client")}
                placeholder={t("tasks.form.fields.client.placeholder")}
                isDisabled={!clients.length}
                value={watch("id_client")}
                onChange={(value: any) => setValue("id_client", value)}
                options={[
                  ...clients?.map((e: any) => ({
                    value: e.cliente_id,
                    label: e.name,
                  })),
                ]}
              />
            </label>

            <label className="flex flex-col gap-1">
              {t("tasks.form.fields.protagonist.label")}
              <Select
                {...register("id_protagonista")}
                placeholder={t("tasks.form.fields.protagonist.placeholder")}
                value={watch("id_protagonista")}
                isDisabled={!watch("id_agency")}
                onInputChange={handleInputChangeProtagonista}
                isLoading={loadigProtagonistas}
                onChange={(value: any) => setValue("id_protagonista", value)}
                options={formatUserData(protagonistas)}
                noOptionsMessage={() => t("common:type_to_search")}
                formatOptionLabel={(user: any) => (
                  <div className="flex gap-2 items-start">
                    <img
                      className="w-6 h-6 rounded-full"
                      src={user.image ?? ImageGeneric}
                      alt={user.label}
                    />
                    <span>{user.label}</span>
                  </div>
                )}
              />
            </label>
          </>
        )}

        {(watch("id_type")?.value === 2 || watch("id_type")?.value === 3) && (
          <label className="flex flex-col gap-1">
            {t("tasks.form.fields.date.label")}
            <Controller
              name="date"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <DatePicker
                  selected={field.value ? new Date(field.value) : null}
                  onChange={(date: Date | null) =>
                    field.onChange(
                      date ? format(date, "yyyy-MM-dd'T'HH:mm") : "",
                    )
                  }
                  dateFormat="dd/MM/yyyy"
                  locale="pt-BR"
                  placeholderText="dd/MM/yyyy"
                  customInput={<CustomDateInput />}
                  wrapperClassName="w-full"
                  popperContainer={CalendarPortal}
                  popperProps={{ strategy: "fixed" }}
                  popperClassName="!z-[9999]"
                />
              )}
            />
          </label>
        )}
        {watch("id_type")?.value != 2 && watch("id_type")?.value != 3 && (
          <label className="flex flex-col gap-1">
            {t("tasks.form.fields.date.label")}
            <Controller
              name="date"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <DatePicker
                  selected={field.value ? new Date(field.value) : null}
                  onChange={(date: Date | null) =>
                    field.onChange(
                      date ? format(date, "yyyy-MM-dd'T'HH:mm") : "",
                    )
                  }
                  dateFormat="dd/MM/yyyy HH:mm"
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  locale="pt-BR"
                  placeholderText="dd/MM/yyyy HH:mm"
                  customInput={<CustomDateInput />}
                  wrapperClassName="w-full"
                  popperContainer={CalendarPortal}
                  popperProps={{ strategy: "fixed" }}
                  popperClassName="!z-[9999]"
                />
              )}
            />
          </label>
        )}
        <label className="flex flex-col gap-1">
          {t("tasks.form.fields.responsible.label")}
          <Select
            placeholder={t("tasks.form.fields.responsible.placeholder")}
            required
            {...register("id_responsavel")}
            onChange={(value: any) => setValue("id_responsavel", value)}
            onInputChange={handleInputChangeUsers}
            isLoading={loadingUsers}
            value={watch("id_responsavel")}
            options={formatUserData(users)}
            noOptionsMessage={() => t("common:type_to_search")}
            formatOptionLabel={(user: any) => (
              <div className="flex gap-2 items-start">
                <img
                  className="w-6 h-6 rounded-full"
                  src={user.image ?? ImageGeneric}
                  alt={user.label}
                />
                <span>{user.label}</span>
              </div>
            )}
          />
        </label>

        <input type="file" {...register(`file_id`)} className="col-span-2" />

        <div className="col-span-2">
          <div className="flex gap-2 items-center">
            <h3 className="text-lg font-medium mb-2">
              {t("tasks.subtasks.title")}
            </h3>
            <button
              type="button"
              className="text-azul-400"
              onClick={() => setIsSubTaskModalOpen(true)}
            >
              <PlusCircle size={18} />
            </button>
          </div>
          <div className="space-y-2">
            {subTasks.map((subTask, index) => (
              <div
                key={index}
                className="flex justify-between items-center border p-2 rounded-lg"
              >
                <div>
                  <p className="font-medium">{subTask.title}</p>
                  <p className="text-sm text-gray-600">{subTask.description}</p>
                </div>
                <button
                  type="button"
                  className="text-red-500"
                  onClick={() => removeSubTask(index)}
                >
                  {t("common:remove")}
                </button>
              </div>
            ))}
          </div>
        </div>
        <button
          className="bg-azul-400 py-2 rounded-lg text-white col-span-2 w-full mx-auto"
          type="submit"
          disabled={isSubmiting}
        >
          {isSubmiting ? t("tasks.buttons.saving") : t("tasks.buttons.save")}
        </button>
      </form>
      {isSubTaskModalOpen && (
        <ModalGeneric
          onClose={() => setIsSubTaskModalOpen(false)}
          size="max-w-md w-full"
        >
          <h3 className="text-lg font-medium mb-4">
            {t("tasks.subtasks.modal.title")}
          </h3>
          <form className="space-y-4" onSubmit={handleSubmit(onSubmitSubTask)}>
            <label className="flex flex-col gap-1">
              {t("tasks.subtasks.fields.title.label")}
              <input
                type="text"
                placeholder={t("tasks.subtasks.fields.title.placeholder")}
                className="bg-cinza-100 rounded-lg py-2 px-5"
                required
                {...register("subtarefa_title")}
              />
            </label>
            <label className="flex flex-col gap-1">
              {t("tasks.subtasks.fields.description.label")}
              <textarea
                placeholder={t("tasks.subtasks.fields.description.placeholder")}
                className="bg-cinza-100 rounded-lg py-2 px-5"
                {...register("subtarefa_description")}
              />
            </label>
            <label className="flex flex-col gap-1">
              {t("tasks.subtasks.fields.responsible.label")}
              <Select
                placeholder={t("tasks.subtasks.fields.responsible.placeholder")}
                required
                {...register("subtarefa_id_responsavel")}
                onChange={(value: any) =>
                  setValue("subtarefa_id_responsavel", value)
                }
                onInputChange={handleInputChangeUsers}
                isLoading={loadingUsers}
                value={watch("subtarefa_id_responsavel")}
                options={formatUserData(users)}
                noOptionsMessage={() => t("common:type_to_search")}
                formatOptionLabel={(user: any) => (
                  <div className="flex gap-2 items-start">
                    <img
                      className="w-5 h-5 rounded-full"
                      src={user.image ?? ImageGeneric}
                      alt={user.label}
                    />
                    <span>{user.label}</span>
                  </div>
                )}
              />
            </label>
            <button
              type="submit"
              className="bg-azul-400 py-2 rounded-lg text-white w-full"
            >
              {t("tasks.subtasks.modal.save")}
            </button>
          </form>
        </ModalGeneric>
      )}
    </ModalGeneric>
  );
}
